document.addEventListener("DOMContentLoaded", () => {
  const toc = document.getElementById("toc");
  if (!toc) return;

  const scope = document.querySelector(".m-article-content");
  if (!scope) return;

  const headings = Array.from(scope.querySelectorAll("h2"));
  if (!headings.length) {
    toc.style.display = "none";
    return;
  }

  const title = document.createElement("div");
  title.className = "m-toc__title";
  title.textContent = "Table of contents";
  toc.appendChild(title);

  const list = document.createElement("ul");
  list.className = "m-toc__list";
  toc.appendChild(list);

  const slugify = (str) =>
    str
      .toLowerCase()
      .trim()
      .replace(/['"]/g, "")
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");

  const used = new Map();
  const uniqueId = (base) => {
    const n = used.get(base) || 0;
    used.set(base, n + 1);
    return n === 0 ? base : `${base}-${n + 1}`;
  };

  headings.forEach((h) => {
    const text = (h.textContent || "").trim();
    if (!text) return;

    if (!h.id) h.id = uniqueId(slugify(text) || "section");

    const li = document.createElement("li");
    li.className = "m-toc__h2";

    const a = document.createElement("a");
    a.href = `#${h.id}`;
    a.textContent = text;

    li.appendChild(a);
    list.appendChild(li);
  });
});